import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { PictureIcon, CaptionText } from '@paypalcorp/pp-react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".styles-module_image_preview_holder__52K-l {\n  background-color: #e6e0d9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.styles-module_image_icon_holder__DBav7 {\n  color: #545d68;\n}\n.styles-module_image_text_holder__NAV4B {\n  margin-left: 12px;\n}\n.styles-module_rounded_corners__gqHUh {\n  border-radius: 12px 12px 0px 0px;\n}\n";
var styles = {
  "image_preview_holder": "styles-module_image_preview_holder__52K-l",
  "image_icon_holder": "styles-module_image_icon_holder__DBav7",
  "image_text_holder": "styles-module_image_text_holder__NAV4B",
  "rounded_corners": "styles-module_rounded_corners__gqHUh"
};
styleInject(css_248z);
var _excluded$1 = ["src", "content", "ariaHidden", "roundedCorners", "displayIcon"];
var Image = function Image(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? '' : _ref$src,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? {
      holderText: ''
    } : _ref$content,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    _ref$roundedCorners = _ref.roundedCorners,
    roundedCorners = _ref$roundedCorners === void 0 ? false : _ref$roundedCorners,
    _ref$displayIcon = _ref.displayIcon,
    displayIcon = _ref$displayIcon === void 0 ? true : _ref$displayIcon,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  if (_isEmpty(src)) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: clsx(styles.image_preview_holder, roundedCorners && styles.rounded_corners)
    }, rest), displayIcon && /*#__PURE__*/React.createElement(PictureIcon, {
      size: "lg",
      className: styles.image_icon_holder
    }), /*#__PURE__*/React.createElement(CaptionText, {
      className: clsx(displayIcon && styles.image_text_holder)
    }, content.holderText));
  }
  return /*#__PURE__*/React.createElement("img", _extends({
    className: clsx(roundedCorners && styles.rounded_corners),
    src: src,
    "aria-hidden": ariaHidden
  }, rest));
};
Image.propTypes = {
  src: PropTypes.string,
  content: PropTypes.shape({
    holderText: PropTypes.string
  }),
  ariaHidden: PropTypes.bool,
  roundedCorners: PropTypes.bool,
  displayIcon: PropTypes.bool
};

var _excluded = ["src", "style"];
var CampaignImage = function CampaignImage(_ref) {
  var src = _ref.src,
    style = _ref.style,
    rest = _objectWithoutProperties$1(_ref, _excluded);
  var containerStyle = _objectSpread2({
    height: '20rem'
  }, style);
  var imageStyles = _objectSpread2({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    maxHeight: 380
  }, style);
  return /*#__PURE__*/React.createElement(Image, _extends$1({
    src: src,
    style: !src ? containerStyle : imageStyles
  }, rest));
};
CampaignImage.propTypes = {
  src: PropTypes.string,
  style: PropTypes.object
};

export { CampaignImage };
